import { useState } from 'react'
import { styled } from 'styled-components'
import Equipment from '../components/homepage/Equipment'
import { AssessmentProcedure } from '../components/homepage/AssessmentProcedure'
import { useEffect } from 'react'
import MovingTheNextGen from '../components/homepage/MovingTheNextGen'
import AssessmentSetup from '../components/homepage/AssessmentSetup'

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    border-radius: 8px;
`

const ContentWrapper = styled.div`
    width: 100%;
    min-height: calc(100vh - 320px);
    padding: 50px 0;
`
interface Prop {
    setTitle: React.Dispatch<React.SetStateAction<string>>
}

const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e6eb;
`
const HeaderContent = styled.div`
    padding-left: 30px;
`

const ButtonGroup = styled.div`
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 30px 50px 30px;
`

const StageButton = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`

const Hr = styled.hr`
    width: 50px;
    height: 2px;
    background-color: #31c690;
    border: none;
`

const Circle = styled.div`
    width: 25px;
    height: 25px;
    border-radius: 15px;
    background-color: #31c690;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
`

export default function Home({ setTitle }: Prop) {
    useEffect(() => {
        setTitle('Get Started')
    }, [])

    const [stage, setStage] = useState<
        | 'MovingTheNextGen'
        | 'Equipment'
        | 'AssessmentSetup'
        | 'AssessmentProcedure'
    >('MovingTheNextGen')

    const handleButtonClick = (
        stage:
            | 'MovingTheNextGen'
            | 'Equipment'
            | 'AssessmentSetup'
            | 'AssessmentProcedure'
    ) => {
        setStage(stage)
    }

    return (
        <Wrapper>
            <Header>
                <HeaderContent>
                    Get Started | Visual breakdown of students’ assessment
                    performance{' '}
                </HeaderContent>
            </Header>
            <ButtonGroup>
                <StageButton
                    onClick={() => handleButtonClick('MovingTheNextGen')}
                >
                    <Circle>1</Circle>
                    Moving The Next Gen
                </StageButton>
                <Hr />
                <StageButton onClick={() => handleButtonClick('Equipment')}>
                    <Circle>2</Circle>
                    Equipment
                </StageButton>
                <Hr />
                <StageButton
                    onClick={() => handleButtonClick('AssessmentSetup')}
                >
                    <Circle>3</Circle>
                    Assessment Setup
                </StageButton>
                <Hr />
                <StageButton
                    onClick={() => handleButtonClick('AssessmentProcedure')}
                >
                    <Circle>4</Circle>
                    Assessment Procedures
                </StageButton>
            </ButtonGroup>
            <ContentWrapper>
                {stage === 'MovingTheNextGen' && (
                    <MovingTheNextGen
                        handleGetStartedClick={handleButtonClick}
                    />
                )}
                {stage === 'Equipment' && (
                    <Equipment handleNextButtonClick={handleButtonClick} />
                )}
                {stage === 'AssessmentSetup' && (
                    <AssessmentSetup
                        handleNextButtonClick={handleButtonClick}
                    />
                )}
                {stage === 'AssessmentProcedure' && <AssessmentProcedure />}
            </ContentWrapper>
        </Wrapper>
    )
}
